import * as React from "react"

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function CompletelySafe() {
  return (
    <S.Container>
      <S.Content>
        <S.Text>
          <h1 className="title-normal">Completely <span>COVID</span> safe</h1>
          <p>We realised the pain point for personal trainers during the pandemic and how the industry has had to adapt to industry crippling lockdowns.</p>
          <p>There needed to be a way for Personal Trainers and other fitness professionals to still make money. After much brain storming and research we realised the online subscription model was the way to go and just like that, Ujoose was born!</p>
        </S.Text>
        <S.Images>
          <StaticImage
            src={`../../images/working-out.png`}
            alt="Working out"
            placeholder="blurred"
            layout="constrained"
          />
        </S.Images>
        <h1 className="title-responsive">Completely <span>COVID</span> safe</h1>
      </S.Content>
    </S.Container>
  )
}